module.exports = __WEBPACK_EXTERNAL_MODULE_5__;


//////////////////
// WEBPACK FOOTER
// external "@ba/ba-ui-carbon-toolkit"
// module id = 5
// module chunks = 0